import { render, staticRenderFns } from "./PublicRoleForm.vue?vue&type=template&id=3afd2b4b&"
import script from "./PublicRoleForm.vue?vue&type=script&lang=ts&"
export * from "./PublicRoleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports